<template>
  <div>
    <vx-card title="" :is-filter="true" class="mb-8" :init-collapsed="true" :collapse-action="true" @keyup.enter="loadAgentInboundDetailsStatistics(1)">
      <template slot="actions">
        <vs-button color="success" type="filled" icon-pack="feather" icon="icon-download" size="small" @click="exportData">{{ $t('export') }}</vs-button>
      </template>

      <div class="vx-row">
        <div class="vx-col md:w-1/2 sm:w-1/2 w-full">
          <date-picker v-model="searchParams.from" :model="searchParams.from" :placeholder="$t('date_filter_from')" class="mb-3"></date-picker>
        </div>
        <div class="vx-col md:w-1/2 sm:w-1/2 w-full">
          <date-picker v-model="searchParams.to" :model="searchParams.to" :placeholder="$t('date_filter_to')" class="mb-3"></date-picker>
        </div>
      </div>

      <template slot="footer">
        <vs-button color="success" type="filled" class="w-full" @click.prevent="loadAgentInboundDetailsStatistics(1)" v-text="$t('search')"></vs-button>
      </template>
    </vx-card>

    <vx-card id="inboundStatisticsDataContainer" :title="$t('inbound_statistics')" class="mb-8 vs-con-loading__container">

      <div class="vx-row">
        <div class="vx-col md:w-2/12 sm:w-2/12 w-full inbound-statistics">
          <table class="table w-full">
            <thead>
              <tr>
                <th v-text="$t('total_calls')" colspan="2" class="text-center text-success font-16"></th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <span class="font-weight-bold mr-2" v-text="`${$t('inbound_details_statistics_inbound')}:`"></span>
                  <span class="badge">
                    <vs-chip color="danger" v-text="result.total_inbound"></vs-chip>
                  </span>
                </td>
                <td>
                  <span class="font-weight-bol mr-2" v-text="`${$t('inbound_details_statistics_outbound')}:`"></span>
                  <span class="badge">
                    <vs-chip color="danger" v-text="result.total_outbound"></vs-chip>
                  </span>
                </td>
              </tr>
            </tbody>
          </table>

          <!-- /.TODO: Convert markup to vuexy list or button -->
          <ul class="box">
            <li v-for="(item, key) in result.dids" :key="key" @click.prevent="selectDid(key)" :class="`${item.selected ? 'active' : ''}`" v-text="item.name"></li>
          </ul>
        </div>

        <div class="vx-col md:w-10/12 sm:w-10/12 w-full">
          <vs-table hover-flat v-if="result.selected.items && result.selected.items.length" :data="result.selected.items">
            <template slot="thead">
              <vs-th v-text="$t('extension_number')"></vs-th>
              <vs-th>
                {{ $t('inbound_details_statistics_inbound') }}&nbsp;
                <span class="badge">
                  <vs-chip color="danger" v-if="result.selected" v-text="result.selected.total_inbound"></vs-chip>
                </span>
              </vs-th>
              <vs-th v-text="$t('inbound_details_statistics_inbound_talk_time')"></vs-th>
              <vs-th>
                {{ $t('inbound_details_statistics_outbound') }}&nbsp;
                <span class="badge">
                  <vs-chip color="danger" v-if="result.selected" v-text="result.selected.total_outbound"></vs-chip>
                </span>
              </vs-th>
              <vs-th v-text="$t('inbound_details_statistics_outbound_talk_time')"></vs-th>
            </template>

            <template slot-scope="{data}">
              <vs-tr :key="key" v-for="(tr, key) in data">
                <vs-td v-text="tr.extension_number"></vs-td>
                <vs-td v-text="tr.inbound"></vs-td>
                <vs-td v-text="tr.inbound_talk_time"></vs-td>
                <vs-td v-text="tr.outbound"></vs-td>
                <vs-td v-text="tr.outbound_talk_time"></vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </div>
      </div>
    </vx-card>
  </div>
</template>

<script>
import DatePicker from '@/components/form-inputs/DatePicker'
import AgentInboundDetailsStatistic from '@/models/AgentInboundDetailsStatistics'

export default {
  name: 'Window.CallStatistics.InboundStatistics',
  components: {
    DatePicker
  },
  data () {
    return {
      result: {
        total_inbound: 0,
        total_outbound: 0,
        selected: {
          key: 0,
          name: '',
          total_inbound: 0,
          total_outbound: 0,
          items: []
        },
        dids: []
      },
      searchParams: {
        from: typeof this.$route.query.from !== 'undefined' ? this.$route.query.from : this.$momentHelper.getCurrentDate(),
        to: typeof this.$route.query.to !== 'undefined' ? this.$route.query.to : this.$momentHelper.getCurrentDate(),
        apiKey: typeof this.$route.query.apiKey !== 'undefined' ? this.$route.query.apiKey : ''
      },
      exportParams: {
        from: typeof this.$route.query.from !== 'undefined' ? this.$route.query.from : this.$momentHelper.getCurrentDate(),
        to: typeof this.$route.query.to !== 'undefined' ? this.$route.query.to : this.$momentHelper.getCurrentDate(),
        companyId: '',
        selected: 0,
        export: false
      }
    }
  },
  async mounted () {
    this.loadAgentInboundDetailsStatistics()
  },
  methods: {
    async loadAgentInboundDetailsStatistics () {

      this.$vs.loading({container: '#inboundStatisticsDataContainer'})

      // this.$store.dispatch('setIsMainTableLoading', true)
      this.$router.replace({ query: { ...this.searchParams } })
      const response = await AgentInboundDetailsStatistic.findAll({ ...this.searchParams })
      this.result.total_inbound = response.data.result.total_inbound
      this.result.total_outbound = response.data.result.total_outbound
      this.result.dids = response.data.result.dids
      this.exportParams.companyId = response.data.company.id
      this.exportParams.from = this.searchParams.from
      this.exportParams.to = this.searchParams.to
      this.selectDid(0)
      // eslint-disable-next-line
      this.$router.push({ name: 'window.call-statistics.inbound-statistics', query: { ...this.searchParams } }).catch(err => {})
      // this.$store.dispatch('setIsMainTableLoading', false)

      this.$vs.loading.close('#inboundStatisticsDataContainer > .con-vs-loading')

    },
    async exportData () {
      this.$store.dispatch('setIsMainTableLoading', true)
      this.exportParams.export = true
      const language = this.$store.getters.userInfo !== null ? this.$store.getters.userInfo.language : 'en'
      // console.log(this.exportParams)
      AgentInboundDetailsStatistic.export({ ...this.exportParams, language })
      this.$store.dispatch('setIsMainTableLoading', false)
    },
    async selectDid (key) {
      const currentSelected = this.result.selected.key
      this.result.dids[currentSelected].selected = false
      this.result.dids[key].selected = true
      this.result.selected = this.result.dids[key]
      this.exportParams.selected = key
      this.result.selected.key = key
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
